import Application from "../../Application";
import { IApplicantService } from "../../service/applicant/ApplicantService";
import { IPositionTypeService } from "../../service/position/PositionTypeService";
import RegisteredApplicantDetailsPresenter, {
  IRegisteredApplicantDetailsPresenter,
  TFormVersionDetailsPresentationModel,
  TFormVersionModalVisible
} from "../../presenter/applicants/RegisteredApplicantDetailsPresenter";
import { IRegisteredApplicant } from "../../model/applicant/RegisteredApplicant";
import { IReportingPeriodService } from "../../service/reporting/ReportingPeriodService";
import { IValueListService } from "../../service/valuelist/ValueListService";
import { CodebookTypes } from "../../common/Constants";
import { IConfiguration } from "../../model/config/Configuration";
import { IConfigurationService } from "../../service/config/ConfigurationService";
import GetIsSignedReportRequiredForAnnouncementInteractor from "./GetIsSignedReportRequiredForAnnouncementInteractor";

export default class ShowRegisteredApplicantDetailsInteractor {
  private application: Application;
  private output?: IRegisteredApplicantDetailsPresenter;
  private applicantService: IApplicantService;
  private positionTypeService: IPositionTypeService;
  private reportingPeriodService: IReportingPeriodService;
  private valueListService: IValueListService;
  private configurationService: IConfigurationService;
  private getIsSignedReportRequiredForAnnouncement: GetIsSignedReportRequiredForAnnouncementInteractor;

  constructor(
    application,
    applicantService,
    positionTypeService,
    reportingPeriodService,
    valueListService,
    configurationService,
    getIsSignedReportRequiredForAnnouncement
  ) {
    this.application = application;
    this.applicantService = applicantService;
    this.positionTypeService = positionTypeService;
    this.reportingPeriodService = reportingPeriodService;
    this.valueListService = valueListService;
    this.configurationService = configurationService;
    this.getIsSignedReportRequiredForAnnouncement =
      getIsSignedReportRequiredForAnnouncement;
  }

  async getData() {
    const [
      positions,
      additionalCheckStatusList,
      configuration,
      isSignedReportRequiredForAnnouncement
    ] = await Promise.all([
      this.positionTypeService.getPositionTypes(),
      this.valueListService.getValueList(
        CodebookTypes.ADDITIONAL_CHECK_STATUS_LIST
      ),
      this.configurationService.getConfiguration(),
      this.getIsSignedReportRequiredForAnnouncement.execute()
    ]);

    return {
      positions,
      additionalCheckStatusList,
      configuration,
      isSignedReportRequiredForAnnouncement
    };
  }

  execute(
    applicantId: number,
    reportingPeriodId?: number,
    defaultTab?: string
  ) {
    this.output = RegisteredApplicantDetailsPresenter({
      application: this.application,
      initialState: {
        applicant: {} as IRegisteredApplicant,
        applicantsAppointments: [],
        positionTypes: [],
        requests: [],
        reportingPeriods: [],
        applicantReportingPeriodPermissions: [],
        requestTypes: [],
        formTypes: [],
        formVersions: [],
        formVersionDetails: {} as TFormVersionDetailsPresentationModel,
        modalVisible: {} as TFormVersionModalVisible,
        reportingPeriodList: [],
        reportingPeriodId,
        defaultTab,
        additionalCheckStatusList: [],
        configuration: {} as IConfiguration,
        isSignedReportRequiredForAnnouncement: true
      }
    });

    this.applicantService
      .getRegisteredApplicants(applicantId)
      .then((applicants) =>
        this.output?.loadApplicantDetails(applicants[0], defaultTab)
      );

    this.getData().then((result) => {
      this.output &&
        this.output.loadInitialData(
          result.positions,
          result.additionalCheckStatusList,
          result.configuration,
          result.isSignedReportRequiredForAnnouncement
        );
    });

    this.reportingPeriodService
      .getReportingPeriods()
      .then((result) => this.output?.setReportingPeriodList(result));

    return this.output;
  }
}
